import actions from '../../actions/machine-state/tool';
import { handleActions } from 'redux-actions';
import { NONE, LONG } from '../../constants/machine-state/tool';

// The set tool is the number last set using a T word
// The loaded tool is the last tool that was loaded using M6. M6 loads the last set tool.

const initialTool = { Z: 0, R: 0, holder: NONE };

const reducer = handleActions(
  {
    [actions.machineState.tool.set]: (state, action) => {
      if(action.payload >= 0) {
        const toolNumber = Math.min(action.payload, 120);
        return { ...state, set: toolNumber };
      } else {
        return state;
      }
    },
    [actions.machineState.tool.change]: (state, action) => ({ ...state, loaded: state.set }),
    [actions.machineState.tool.setToolLengthOffset]: (state, action) => {
      const { H } = action.payload;

      let toolIndex = state.loaded;
      if( H !== undefined && H > 0) {
        toolIndex = H;
      }

      toolIndex = Math.min(toolIndex, 120);

      const tool = state.table[toolIndex];

      return {
        ...state,
        toolLengthOffset: tool 
      };
    },
    [actions.machineState.tool.clearToolLengthOffset]: (state, action) => ({
      ...state,
      toolLengthOffset: initialTool
    }),
    [actions.machineState.tool.table.setTool]: (state, action) => {
      const { P: toolNumber, X, Y, Z, A, B, C, U, V, W, R, I, J, Q, holder, type } = action.payload;
      let params = { X, Y, Z, A, B, C, U, V, W, R, I, J, Q, holder, type };
      for(const key in params) {
        if(params[key] === undefined) {
          delete params[key];
        }
      }
      const table = [ ...state.table ];
      if(toolNumber > 0) {
        table[toolNumber] = {
          ...table[toolNumber],
          ...params
        };
      }

      return { 
        ...state,
        table 
      };
    }
  },
  {
    set: 0,
    loaded: 0,
    toolLengthOffset: initialTool,
    table: [
     { Z: 0, R: 0, holder: NONE },
     { Z: 5.9678, R: 1.25, holder: "H1" },
     { Z: 6.3624, R: 0.25, holder: "H2" },
     { Z: 7.7641, R: 0.25, holder: "H2" },
     { Z: 7.441, R: 0.125, holder: "H3" },
     { Z: 7.4811, R: 3./16*.5, holder: "H3" },
     { Z: 8.0701, R: 1/8*.5, holder: "H4" },
     { Z: 7.2689, R: 7.5/25.4*.5, holder: "H12" },
     { Z: 8.7944, R: 6.8/25.4*.5, holder: "H6" },
     { Z: 8.8888, R: 6/25.4*.5, holder: "H6" }, // Missing holder
     { Z: 9.0095, R: 4.5/25.4*.5, holder: "H6" }, // Missing holder
     { Z: 8.7029, R: 3.3/25.4*.5, holder: "H6" }, // Missing
     { Z: 8.5376, R: 2.5/25.4*.5, holder: "H7" },
     { Z: 8.0933, R: 8/25.4*.5, holder: "H6" },
     { Z: 7.81, R: 6/25.4*.5, holder: "H3" },
     { Z: 8.6807, R: 4/25.4*.5, holder: "H8" },
     { Z: 7.414, R: 3/25.4*.5, holder: "H3" },
     { Z: 8.5373, R: 4/25.4*.5, holder: "H9" },
     { Z: 8.9777, R: .1255*.5, holder: "H3" },
     { Z: 8.0139, R: .1255*.5, holder: "H3" },
     { Z: 7.4274, R: .375*.5, holder: "H3" },
     { Z: 7.5127, R: 5/25.4*.5, holder: "H3" }, // 21 Missing
     { Z: 9.1364, R: .75*.5, holder: "H2" },
     { Z: 8.8794, R: 5/25.4*.5, holder: "H3" }, // Missing
     { Z: 7.8865, R: 1.5/25.4*.5, holder: "H10" },
     { Z: -3, R: .0625, holder: LONG },
     { Z: 8.6912, R: 5/25.4*.5, holder: "H8" },
     { Z: -3, R: .0625, holder: LONG },
     { Z: -3, R: .0625, holder: LONG },
     { Z: 8.1282, R: 15/25.4*.5, holder: "H11" },
     { Z: 7.3679, R: .5*.5, holder: "H12" },
     { Z: 7.1642, R: 3/4*.5, holder: "H12" },
     { Z: 9.1483, R: .75*.5, holder: "H12" },
     { Z: 12.3794, R: 26/25.4*.5, holder: "H13" },
     { Z: 9.4082, R: 10.5/25.4*.5, holder: "H14" },
     { Z: 8.177, R: 4/25.4*.5, holder: "H3", type: "BALL" }, // Missing
     { Z: 8.1841, R: 10/25.4*.5, holder: "H6" },
     { Z: -3, R: .0625, holder: LONG },
     { Z: -3, R: .0625, holder: LONG },
     { Z: -3, R: .0625, holder: LONG },
     { Z: 8.9411, R: .124*.5, holder: "H3" },
     { Z: 9.2075, R: 4/25.4*.5, holder: "H17", type: "PROBE" },
     { Z: 8.7056, R: 8/25.4*.5, holder: "H6" },
     { Z: 13.6146, R: 8/25.4*.5, holder: "H11" },
     { Z: 9.6655, R: 7.5/25.4*.5, holder: "H15" },
     { Z: -3, R: .0625, holder: LONG },
     { Z: 6.86, R: 4.5/25.4*.5, holder: "H3" },
     { Z: -3, R: .0625, holder: LONG },
     { Z: 7.7475, R: .5*.5, holder: "H2" }, // Missing
     { Z: -3, R: .0625, holder: LONG },
     { Z: -3, R: .0625, holder: LONG },
     { Z: -3, R: .0625, holder: LONG },
     { Z: -3, R: .0625, holder: LONG },
     { Z: -3, R: .0625, holder: LONG },
     { Z: -3, R: .0625, holder: LONG },
     { Z: -3, R: .0625, holder: LONG },

     { Z: 7.7475, R: .5*.5, holder: "H2" }, // Missing
     { Z: 7.7475, R: .5*.5, holder: "H2" }, // Missing
     { Z: 7.7475, R: .5*.5, holder: "H2" }, // Missing
     { Z: 7.7475, R: .5*.5, holder: "H2" }, // Missing
     { Z: 7.7475, R: .5*.5, holder: "H2" }, // Missing

     { Z: 7.7475, R: .5*.5, holder: "H2" }, // Missing
     { Z: 9, R: 1.25, holder: "H1" }, // Missing
     { Z: 7.7475, R: .5*.5, holder: "H2" }, // Missing
     { Z: 7.7475, R: .5*.5, holder: "H2" }, // Missing
     { Z: 7.7475, R: .5*.5, holder: "H2" }, // Missing

     { Z: 7.7475, R: .5*.5, holder: "H2" }, // Missing
     { Z: 7.7475, R: .5*.5, holder: "H2" }, // Missing
     { Z: 7.7475, R: .5*.5, holder: "H2" }, // Missing
     { Z: 7.7475, R: .5*.5, holder: "H2" }, // Missing
     { Z: 7.7475, R: .5*.5, holder: "H2" }, // Missing

     { Z: 7.7475, R: .5*.5, holder: "H2" }, // Missing
     { Z: 7.7475, R: .5*.5, holder: "H2" }, // Missing
     { Z: 7.7475, R: .5*.5, holder: "H2" }, // Missing
     { Z: 7.7475, R: .5*.5, holder: "H2" }, // Missing
     { Z: 7.7475, R: .5*.5, holder: "H2" }, // Missing

     { Z: 7.7475, R: .5*.5, holder: "H2" }, // Missing
     { Z: 7.7475, R: .5*.5, holder: "H2" }, // Missing
     { Z: 7.7475, R: .5*.5, holder: "H2" }, // Missing
     { Z: 7.7475, R: .5*.5, holder: "H2" }, // Missing
     { Z: 7.7475, R: .5*.5, holder: "H2" }, // Missing

     { Z: 7.7475, R: .5*.5, holder: "H2" }, // Missing
     { Z: 7.7475, R: .5*.5, holder: "H2" }, // Missing
     { Z: 7.7475, R: .5*.5, holder: "H2" }, // Missing
     { Z: 7.7475, R: .5*.5, holder: "H2" }, // Missing
     { Z: 7.7475, R: .5*.5, holder: "H2" }, // Missing

     { Z: 7.7475, R: .5*.5, holder: "H2" }, // Missing
     { Z: 7.7475, R: .5*.5, holder: "H2" }, // Missing
     { Z: 7.7475, R: .5*.5, holder: "H2" }, // Missing
     { Z: 7.7475, R: .5*.5, holder: "H2" }, // Missing
     { Z: 7.7475, R: .5*.5, holder: "H2" }, // Missing

     { Z: 7.7475, R: .5*.5, holder: "H2" }, // Missing
     { Z: 7.7475, R: .5*.5, holder: "H2" }, // Missing
     { Z: 7.7475, R: .5*.5, holder: "H2" }, // Missing
     { Z: 7.7475, R: .5*.5, holder: "H2" }, // Missing
     { Z: 7.7475, R: .5*.5, holder: "H2" }, // Missing

     { Z: 7.7475, R: .5*.5, holder: "H2" }, // Missing
     { Z: 7.7475, R: .5*.5, holder: "H2" }, // Missing
     { Z: 7.7475, R: .5*.5, holder: "H2" }, // Missing
     { Z: 7.7475, R: .5*.5, holder: "H2" }, // Missing
     { Z: 7.7475, R: .5*.5, holder: "H2" }, // Missing

     { Z: 7.7475, R: .5*.5, holder: "H2" }, // Missing
     { Z: 7.7475, R: .5*.5, holder: "H2" }, // Missing
     { Z: 7.7475, R: .5*.5, holder: "H2" }, // Missing
     { Z: 7.7475, R: .5*.5, holder: "H2" }, // Missing
     { Z: 7.7475, R: .5*.5, holder: "H2" }, // Missing

     { Z: 7.7475, R: .5*.5, holder: "H2" }, // Missing
     { Z: 7.7475, R: .5*.5, holder: "H2" }, // Missing
     { Z: 7.7475, R: .5*.5, holder: "H2" }, // Missing
     { Z: 7.7475, R: .5*.5, holder: "H2" }, // Missing
     { Z: 7.7475, R: .5*.5, holder: "H2" }, // Missing

     { Z: 7.7475, R: .5*.5, holder: "H2" }, // Missing
     { Z: 7.7475, R: .5*.5, holder: "H2" }, // Missing
     { Z: 7.7475, R: .5*.5, holder: "H2" }, // Missing
     { Z: 7.7475, R: .5*.5, holder: "H2" }, // Missing
     { Z: 7.7475, R: .5*.5, holder: "H2" }, // Missing

     { Z: 7.7475, R: .5*.5, holder: "H2" }, // Missing
     { Z: 7.7475, R: .5*.5, holder: "H2" }, // Missing
     { Z: 7.7475, R: .5*.5, holder: "H2" }, // Missing
     { Z: 7.7475, R: .5*.5, holder: "H2" }, // Missing
     { Z: 7.7475, R: .5*.5, holder: "H2" }, // Missing
    ]
  }
);

export default reducer;
